import { render } from "./DashBox.vue?vue&type=template&id=3e7f05f6&scoped=true"
import script from "./DashBox.vue?vue&type=script&lang=js"
export * from "./DashBox.vue?vue&type=script&lang=js"

import "./DashBox.vue?vue&type=style&index=0&id=3e7f05f6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e7f05f6"]])

export default __exports__